import { FC, PropsWithChildren } from 'react'

import { StencilPreset } from '@/features/stencil/StencilPreset/StencilPreset'

type LayoutMainProps = {}

export const LayoutMain: FC<PropsWithChildren<LayoutMainProps>> = (props) => {
  const { children } = props
  return <StencilPreset>{children}</StencilPreset>
}
